import React, { useState } from 'react';
import styled from 'styled-components';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import FaqrightImage from '../images/homepage/img1.png';

const faqs = [
  {
    question: "Schedule Jobs That Fit Your Workflow",
    answer: (
      <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
        <li><CheckCircleIcon style={{ verticalAlign: 'middle', color: 'white', marginRight: '8px' }} />Drag & Drop Scheduling</li>
        <li><CheckCircleIcon style={{ verticalAlign: 'middle', color: 'white', marginRight: '8px' }} />Real-Time Calendar Updates</li>
        <li><CheckCircleIcon style={{ verticalAlign: 'middle', color: 'white', marginRight: '8px' }} />Recurring Job Management</li>
        <li><CheckCircleIcon style={{ verticalAlign: 'middle', color: 'white', marginRight: '8px' }} />Technician Availability View</li>
        <li><CheckCircleIcon style={{ verticalAlign: 'middle', color: 'white', marginRight: '8px' }} />Automated Appointment Reminders</li>
      </ul>
    )
  },
  {
    question: "Is ServTrackr suitable for small businesses?",
    answer: "Absolutely! ServTrackr is built to support businesses of all sizes, including small businesses, with flexible features that scale as you grow."
  },
  {
    question: "How does ServTrackr help improve team productivity?",
    answer: "Absolutely! ServTrackr is built to support businesses of all sizes, including small businesses, with flexible features that scale as you grow."
  },
  {
    question: "Can I integrate ServTrackr with my existing tools?",
    answer: "Absolutely! ServTrackr is built to support businesses of all sizes, including small businesses, with flexible features that scale as you grow."
  },
  {
    question: "Can I track customer communications in ServTrackr?",
    answer: "Absolutely! ServTrackr is built to support businesses of all sizes, including small businesses, with flexible features that scale as you grow."
  },
   {
    question: "Can I schedule jobs for my team in ServTrackr?",
    answer: "Absolutely! ServTrackr is built to support businesses of all sizes, including small businesses, with flexible features that scale as you grow."
  },
   {
    question: "How secure is my data with ServTrackr?",
    answer: "Absolutely! ServTrackr is built to support businesses of all sizes, including small businesses, with flexible features that scale as you grow."
  }
];

const FaqSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <Faqbox>
      

      <FaqContent>
        <FaqItems>
          {faqs.map((item, index) => {
            const isActive = activeIndex === index;
            return (
              <AccordionItem key={index}>
                <Question onClick={() => toggleAccordion(index)} isActive={isActive}>
                  {item.question}
                  <span className="toggle-icon">{isActive ? '-' : '+'}</span>
                </Question>
                {isActive && (
                  <>
                    <Answer>
                      {typeof item.answer === 'string' ? (
                        <p>{item.answer}</p>
                      ) : (
                        item.answer
                      )}
                    </Answer>
                  </>
                )}
              </AccordionItem>
            );
          })}
        </FaqItems>

        <DesktopImageWrapper>
          <h2>
          Frequently Asked <br />
          <span>Questions</span>
        </h2>
        <p>Got questions? We’ve got answers. Browse through common queries to learn more about how ServTrackr can support your service business.</p>
        <button class="btn">Learn More <ArrowForwardIcon style={{ marginLeft: '8px', verticalAlign: 'middle', fill: '#fff' }} /></button>
        </DesktopImageWrapper>
      </FaqContent>
    </Faqbox>
  );
};

export default FaqSection;

// Styled Components
const Faqbox = styled.div`
  padding: 5rem 7rem;
  text-align: left;

  @media screen and (max-width: 700px) {
      padding: 0rem 1rem !important;
  }

  @media screen and (min-width: 701px) and (max-width: 1100px) {
        padding: 5rem 2rem !important;
    }
  h2 {
    font-size: 32px;
    line-height: 1.4;
    font-weight: 700;

    @media screen and (max-width: 700px) {
       font-size: 30px;
       text-align: center !important;
  }

    span {
      color: #4F46E5;
    }
  }
`;

const FaqContent = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
  flex-wrap: wrap;
  flex-direction: row-reverse;

  @media screen and (max-width: 700px) {
    flex-direction: column-reverse;
  }
    @media screen and (min-width: 701px) and (max-width: 1100px) {
         flex-direction: column-reverse;
    align-items: anchor-center;
    }
`;

const FaqItems = styled.div`
  flex: 1;
  min-width: 300px;
  max-width: 600px;

  @media screen and (max-width: 700px) {
    margin-top: 20px;
  }
  
  @media screen and (min-width: 701px) and (max-width: 1100px) {
      width: 90%;
      max-width: 90%;
      margin-top: 30px;
    }
  
`;

const AccordionItem = styled.div`
  margin-bottom: 20px;
  background: #F4F4F4 !important;
  border-radius: 24px;
`;

const Question = styled.div`
  background-color: ${({ isActive }) => (isActive ? '#4F46E5' : 'transparent')};
  color: ${({ isActive }) => (isActive ? '#fff' : '#000')};
  padding: 1.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 20px;
  font-family: 'BlinkMacSystemFont', sans-serif;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;

  .toggle-icon {
    color: ${({ isActive }) => (isActive ? '#fff' : '#000')};
  }
`;

const Answer = styled.div`
  background-color: #4F46E5;
  padding: 10px 30px 30px 30px;
  font-family: 'Poppins', sans-serif;
  color: #fff !important;
  font-size: 15px;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;

  p{
    color: ${({ isActive }) => (isActive ? '#fff !important' : '#fff')};
  }
`;

const DesktopImageWrapper = styled.div`
  flex: 0 0 30%;
  width: 30%;

  @media screen and (max-width: 700px) {
    flex: 0 0 100%;
    width: 100%;
  }
    @media screen and (min-width: 701px) and (max-width: 1100px) {
      flex: 0 0 90%;
      width: 90%;
    }

  h2{
  text-align: left !important;
  font-size: 40px;

  @media screen and (max-width: 700px) {
       text-align: center !important;
  }
       @media screen and (min-width: 701px) and (max-width: 1100px) {
         text-align: center !important;
    }

  span{
    background: linear-gradient(to right, #DD8FF9 0%, #A975FE 33%, #4F46E5 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  }
  p{
    font-weight: 400 !important;
    padding: 20px 0;
    color: #5B5B5B ;

    @media screen and (max-width: 700px) {
       text-align: center !important;
  }
       @media screen and (min-width: 701px) and (max-width: 1100px) {
         text-align: center !important;
    }
  }

  @media (max-width: 768px) {
       display: flex;
        flex-direction: column;
        align-items: anchor-center;
  }
  @media screen and (min-width: 701px) and (max-width: 1100px) {
        display: flex;
        flex-direction: column;
        align-items: anchor-center;
    }
`;

const MobileImageWrapper = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
    margin-top: 20px;

    img {
      width: 100%;
      height: auto;
    }
  }
`;
